import { ProcedimentoSelectModel } from 'components/form/field/select/ProcedimentoSelectField'

import { RowType } from './detail/components/EditableList'

/**
 * Códigos de exceção para procedimentos AB que são considerados exceção em alguns serviços.
 * Geralmente, a regra adotada é a seguinte:
 * - Se o procedimento é AB e possui SIGTAP relacionado, são apresentadas as informações do procedimento SIGTAP;
 * - Se o procedimento é AB e não possui SIGTAP relacionado, são apresentadas as informações do procedimento AB;
 * - Se o procedimento é SIGTAP, apresenta as informações normalmente.
 *
 * Existem no momento 4 procedimentos AB que não possuem SIGTAP relacionados: ABEX012, ABEX013, ABEX022 e ABPG042.
 */
export const EXCEPTION_AB_CODES = ['ABEX012', 'ABEX013', 'ABEX022', 'ABPG042']

export interface ProcedimentoModel extends RowType {
  procedimento: ProcedimentoSelectModel
  automatico?: boolean
}
